import {call, put, takeLatest, delay} from 'redux-saga/effects'
import {actions} from './action'
import {actionTypes} from './constants'
import {ResponseModel} from 'src/cms/helpers/Models/ResponseModel'
import {service} from './service'
import {IProductSchemeState} from './reducer'
import {ActionModel} from 'src/cms/helpers/Models/ActionModel'
import {globalActionTypes} from 'src/app/modules/errors/redux/constants'

function* getKeySaga(action: ActionModel) {
  try {
    const params: any = action.payload?.params
    yield delay(500)
    const response: ResponseModel = yield call(service.getProductScheme, params)
    const data = response?.data
    yield put(actions.getProductSchemeSuccess(data))
    yield put({type: actionTypes.GET_PRODUCT_SCHEME_FINISH})
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put({type: actionTypes.GET_PRODUCT_SCHEME_FINISH})
  }
}

function* getProductSchemeDropdownSaga(action: ActionModel) {
  try {
    yield delay(500)
    const response: ResponseModel = yield call(service.getProductSchemeDropdown)
    const data = response?.data
    yield put(actions.getProductSchemeDropdownSuccess(data))
    yield put({type: actionTypes.GET_PRODUCT_SCHEME_DROPDOWN_FINISH})
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put({type: actionTypes.GET_PRODUCT_SCHEME_DROPDOWN_FINISH})
  }
}

function* CreateKey(action: ActionModel) {
  try {
    const body = action.payload
    const response: ResponseModel = yield call(service.postProductScheme, body)
    yield put({type: actionTypes.ADD_PRODUCT_SCHEME_SUCCESS, payload: response.data})
    yield put({type: actionTypes.ADD_PRODUCT_SCHEME_FINISH})
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put({type: actionTypes.ADD_PRODUCT_SCHEME_FINISH})
  }
}

function* updateKey(action: ActionModel) {
  try {
    const body: any = action.payload?.data
    const response: ResponseModel = yield call(service.updateProductScheme, body, action.payload?.id)
    yield put({type: actionTypes.UPDATE_PRODUCT_SCHEME_SUCCESS, payload: response.data})
    yield put({type: actionTypes.UPDATE_PRODUCT_SCHEME_FINISH})
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put({type: actionTypes.UPDATE_PRODUCT_SCHEME_FINISH})
  }
}

function* deleteKeySaga(action: ActionModel) {
  try {
    const body: any = action.payload
    const response: ResponseModel = yield call(service.deleteProductScheme, body)
    yield put({type: actionTypes.DELETE_PRODUCT_SCHEME_SUCCESS, payload: response.data})
    yield put({type: actionTypes.DELETE_PRODUCT_SCHEME_FINISH})
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put({type: actionTypes.DELETE_PRODUCT_SCHEME_FINISH})
  }
}

function* singleActivateProductScheme(action: ActionModel) {
  try {
    const selectedProductScheme: any = action.payload
    yield delay(100)
    const response: ResponseModel = yield call(
      service.singleActivatedProductScheme,
      selectedProductScheme
    )
    yield put({
      type: actionTypes.SINGLE_ACTIVATE_PRODUCT_SCHEME_SUCCESS,
      payload: response?.data?.data,
    })
    yield put({type: actionTypes.SINGLE_ACTIVATE_PRODUCT_SCHEME_FINISH})
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put({type: actionTypes.SINGLE_ACTIVATE_PRODUCT_SCHEME_FINISH})
  }
}

function* singleDeactivateProductScheme(action: ActionModel) {
  try {
    const selectedProductScheme: any = action.payload
    yield delay(100)
    const response: ResponseModel = yield call(
      service.singleDeactivatedProductScheme,
      selectedProductScheme
    )

    yield put({
      type: actionTypes.SINGLE_DEACTIVATE_PRODUCT_SCHEME_SUCCESS,
      payload: response?.data?.data,
    })
    yield put({type: actionTypes.SINGLE_DEACTIVATE_PRODUCT_SCHEME_FINISH})
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put({type: actionTypes.SINGLE_DEACTIVATE_PRODUCT_SCHEME_FINISH})
  }
}

export function* saga() {
  yield takeLatest(actionTypes.GET_PRODUCT_SCHEME_START, getKeySaga)
  yield takeLatest(actionTypes.GET_PRODUCT_SCHEME_DROPDOWN_START, getProductSchemeDropdownSaga)
  yield takeLatest(actionTypes.ADD_PRODUCT_SCHEME_START, CreateKey)
  yield takeLatest(actionTypes.DELETE_PRODUCT_SCHEME_START, deleteKeySaga)
  yield takeLatest(actionTypes.UPDATE_PRODUCT_SCHEME_START, updateKey)
  yield takeLatest(actionTypes.SINGLE_ACTIVATE_PRODUCT_SCHEME_REQUEST, singleActivateProductScheme)
  yield takeLatest(actionTypes.SINGLE_DEACTIVATE_PRODUCT_SCHEME_REQUEST, singleDeactivateProductScheme)
}
